const NAME = 'materialTextFields';

import {MDCTextField} from '@material/textfield';
import {purgeEls} from '@netx/core/utils';
import {notchOutlinePatch} from './patches/mdc-textfield';

export default function (target) {
	if (!target || target.hasFunctionality(NAME)) return target;

	target.addInitializer((instance, opts = {}) => {
		let materialTextFields = [];
		let dateComponents = [];

		const cleanUp = () => {
			_.invoke(materialTextFields, 'destroy');
			materialTextFields = [];
			dateComponents = [];
		};

		const getMaterailTextField = (el) => {
			for (let i = 0, c = materialTextFields.length; i < c; i++) {
				const textField = materialTextFields[i];
				if (textField.input_ === el) {
					return textField;
				}
			}
		};

		instance.events = {
			'change .mdc-text-field [data-provide="datepicker"]'(e) {
				const target = e.currentTarget;
				dateComponents.forEach((textField) => {
					if (textField.input_ !== target) return;
					// This will fix the floating label and validation
					const foundation = textField.foundation_;
					foundation.deactivateFocus();
				});
			},
			...instance.events,
		};

		instance.materialTextFieldFloatLabel = (el, shouldFloat = false) => {
			const textField = getMaterailTextField(el);
			if (!textField || !textField.label_) return;
			textField.label_.float(shouldFloat);
			textField.foundation_.notchOutline &&
				textField.foundation_.notchOutline(shouldFloat);
		};

		// Hey, listen!
		instance
			.on('preRenderHook', cleanUp)
			.on('removeHook', cleanUp)
			.on('postRenderHook', () => {
				dateComponents = [];
				materialTextFields = purgeEls(
					[...instance.el.querySelectorAll('.mdc-text-field')],
					instance.getExcludedViews(),
				).map((field) => {
					// Hack for typeahead - we want the styles but mdc will grab it first (since it gets prepended)
					// Remove the class before creating mdc-text-field and then re-add
					const ttInputEl = field.querySelector(
						'.mdc-text-field__input.tt-hint',
					);
					if (ttInputEl) {
						ttInputEl.classList.remove('mdc-text-field__input');
					}

					const inputEl = field.querySelector('.mdc-text-field__input');
					if (!inputEl) return;

					const textField = new MDCTextField(field);
					if (field.classList.contains('mdc-text-field--textarea')) {
						notchOutlinePatch(textField);
					}

					if (inputEl.getAttribute('data-provide') === 'datepicker') {
						dateComponents.push(textField);
					}

					// Put the class back for styles
					if (ttInputEl) {
						ttInputEl.classList.add('mdc-text-field__input');
					}

					return textField;
				});
			});
	}, NAME);

	return target;
}
